import gql from 'graphql-tag'

export default gql`
  mutation orders_update_mutation($id: ID!, $giftDate: Date!) {
    orderUpdate(id: $id, giftDate: $giftDate) {
      id
    }
  }
`
